// extracted by mini-css-extract-plugin
module.exports = {"content":"_16HND","day":"ROOm4","past":"_1DT9B","dayText":"_23Qs5","today":"_3ZJsc","events":"_2MfWh","event":"_14YFY"};